import axios from "axios";
import { toast } from "react-toastify";

export const register = (
  firstName: string,
  lastName: string,
  emailAddress: string,
  companyName: string,
  password: string,
  setIsOpen: Function
) => {
  axios
    .post(`api/auth/register`, {
      firstName,
      lastName,
      emailAddress,
      companyName,
      password,
    })
    .then(() => {
      toast.success("Un mail vous a été envoyé pour vérifier votre compte.", {
        className: "toast-success",
      });
      setIsOpen(false);
    })
    .catch((err) => {
      if (process.env.NODE_ENV !== "production") {
        console.error("An error occurred while registering", err);
      }
      toast.error(
        "Ce compte n'existe pas ou le mot de passe ne correspond pas.",
        {
          className: "toast-error",
        }
      );
    });
};
